export default {
    差价合约:'ETF 差價合約',
    把握全球:'交易全球100隻熱門ETF差價合約，涵蓋：寬基股票ETF、債券/固收類ETF、區域/國家主題ETF、行業/主題ETF、紅利ETF、槓桿/特殊ETF等。免基金賬戶、雙向交易、槓桿加持！',
    即刻开户:'即刻開戶',
    优势:'優勢',
    差价合约是一种:'ETF 差價合約是一種靈活的金融工具，支持全球主流 ETF 的槓桿雙向交易，適合希望捕捉市場波動、進行多樣化配置的投資者。',
    品种丰富:'品種豐富',
    支持100:'支持100種熱門ETF CFD交易',
    灵活交易:'靈活交易',
    支持买入:'支持買入/賣出，捕捉漲跌機會',
    无需持有:'無需持有',
    无需持有资产:'無需持有資產，輕鬆交易全球ETF',
    杠杆交易:'槓桿交易',
    杠杆配置:'5:1槓桿配置，提升資金使用效率',
    开设模拟账户:'開設模擬帳戶',
    开设真实账户:'開設真實帳戶',
    如何开始交易:'如何開始交易',
    注册账号:'註冊帳號',
    注册并登录:'註冊並登入用戶中心，完成身份認證',
    下载MT5交易平台:'下載MT5交易平台',
    开通真实交易账号:'開通真實交易帳號',
    开始交易:'開始交易',
    选择ETF:'選擇ETF CFD產品',
    即刻交易:'即刻交易',
    差价合约相关问题:'ETF 差價合約相關問題',
    ETF是什么:'1. ETF是什麼？',
    ETF全称是:'ETF全稱是「交易型開放式指數基金」，簡單說就是把一堆股票打包成一個套餐，放在股市裡買賣。比如你想買科技股但不會選，買科技ETF就等於同時持有蘋果、微軟等一堆科技公司股票。',
    有什么区别:'2. ETF CFD 和傳統 ETF 有什麼區別？',
    是差价合约交易:'ETF CFD 是差價合約交易，不涉及實物資產交割，無需開戶證券帳戶，也無需持有ETF份額；更適合短線、雙向、槓桿交易策略。',
    购买ETF才能交易:'3. 是否需要實際購買ETF才能交易？',
    通过EBC提供的ETF:'不需要。通過EBC提供的ETF CFD產品，您無需持有ETF即可交易ETF價格波動，所有操作均在交易平台內完成。',
    交易会收取哪些费:'4. ETF CFD 交易會收取哪些費用？',
    您无需支付传统ETF的管理费:'您無需支付傳統ETF的管理費與佣金。交易成本主要為點差和過夜持倉的融資費用，具體費用在平台上即時展示。',
    可以做空吗:'5. ETF CFD 可以做空嗎？',
    与传统ETF只能做多不:'可以。與傳統ETF只能做多不同，ETF CFD支持看空交易，適合震盪市或下跌行情下的策略部署。',
    适合新手交易者:'6. ETF CFD 適合新手交易者嗎？',
    CFD产品具有杠杆属性:'CFD產品具有槓桿屬性，適合有一定風險意識和交易經驗的用戶。我們建議新手通過模擬帳戶熟悉產品機制後再進行實盤交易。',
    市场报价:'市場報價',
    查看所有产品:'查看所有產品',
}